export default __webpack_public_path__ + "static/media/panierMoins.c50697fd.svg";